import type { FC, FormEvent } from 'react'
import { useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'

import type { ReplyFormProps } from './types'
import { scrollToBottomOfConversation } from './utils'

const ReplyForm: FC<ReplyFormProps> = ({
  postId,
  isSubmitting,
  isMobile,
  onSubmit,
  lastMessageId,
  autoFocus = true,
}) => {
  const [replyMessage, setReplyMessage] = useState('')

  const handleReplyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    setReplyMessage(value)
  }

  const handleReplySubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (postId && replyMessage.trim() && lastMessageId) {
      onSubmit(replyMessage.trim(), lastMessageId)
      setReplyMessage('') // Clear form after submission
    }
  }

  return (
    <div className="w-full lg:max-w-[360px] p-[8px] bg-[#fee5e1] rounded-b-[8px]">
      <form onSubmit={handleReplySubmit}>
        <TextareaAutosize
          id="change_details"
          data-testid="change_details"
          data-textarea-postid={postId}
          onChange={handleReplyChange}
          value={replyMessage}
          placeholder="Enter feedback"
          required
          className="p-[8px] bg-[#ffffff] rounded-[8px] w-full h-[64px] mb-[4px] min-h-[64px] max-h-[100px] placeholder:text-[#c4c4c4] border border-gray-300 resize-none font-[Inter] text-[12px] leading-[16px] text-[#333] focus:outline-none"
          onHeightChange={(height) => {
            // scroll to bottom if textarea height hit a certain limit
            if (height >= 90) {
              scrollToBottomOfConversation()
            }
          }}
          onClick={(e) => {
            // mobile
            e.stopPropagation()
          }}
          autoFocus={!isMobile && autoFocus} // can't do native autofocus on mobile because it will have multiple textarea on the page
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="py-[7px] px-[26px] border-none font-[600] text-[12px] bg-[#fa4f38] text-[#ffffff] rounded-[8px] flex items-center justify-center flex ml-auto cursor-pointer disabled:opacity-70 disabled:cursor-wait"
          onClick={(e) => {
            // mobile
            e.stopPropagation()
          }}
        >
          Send
        </button>
      </form>
    </div>
  )
}

export default ReplyForm
